export function monthsBeforeFRA(fraYears, fraMonths, startYears, startMonths) {
  const fraTotalMonths = fraYears * 12 + fraMonths;
  const startTotalMonths = startYears * 12 + startMonths;
  return fraTotalMonths - startTotalMonths; // months early (positive = early)
}

export function percentOfFRA(monthsEarly) {
  let reduction = 0;
  if (monthsEarly <= 36) {
    reduction = (monthsEarly * (5 / 9)) / 100;
  } else {
    reduction = (36 * (5 / 9)) / 100 + ((monthsEarly - 36) * (5 / 12)) / 100;
  }
  return 1 - reduction; // % of FRA
}

export function monthlyBenefit(fraBenefit, monthsEarly) {
  return fraBenefit * percentOfFRA(monthsEarly);
}

export function preFRABenefit(monthlyBenefit, monthsEarly) {
  return monthlyBenefit * monthsEarly;
}

export function monthsToBreakeven(fraBenefit, earlyBenefit, preFraBenefit) {
  return Math.ceil(preFraBenefit / (fraBenefit - earlyBenefit));
}

export function ageAtBreakeven(startYears, startMonths, monthsToBreakEven,fraYears) {
  const totalMonths = fraYears * 12 + startMonths + monthsToBreakEven; // I have replace startYears with FRAyears in this formula according to new sheet
  const years = Math.floor(totalMonths / 12);
  const months = Math.round(totalMonths % 12);
  const formatted = `${parseInt(years)} years and ${parseInt(months)} months`;
  return {
    years: years,
    months: months,
    decimal: totalMonths / 12, // e.g. 70.5
    formatted: formatted,
  };
}

export function futureValuePreFRA(monthlyBenefit, monthsEarly, colaRate) {
  let fv = 0;
  for (let m = 1; m <= monthsEarly; m++) {
    fv += monthlyBenefit * Math.pow(1 + colaRate, (monthsEarly - m) / 12);
  }
  return fv;
}

export function monthsToBreakevenWithCOLA(
  fraBenefit,
  earlyBenefit,
  futureValue
) {
  return Math.ceil(futureValue / (fraBenefit - earlyBenefit));
}

export function buildEarlyRetirementTable(
  fraYears,
  fraMonths,
  fraBenefit,
  colaRate = 0.02
) {
  const results = [];

  // Start from 62 up to FRA - 1 year
  for (let age = 62; age < fraYears; age++) {
    const startYears = age;
    const startMonths = 0; // whole year (you can later extend to partial)
    const monthsEarly = monthsBeforeFRA(
      fraYears,
      fraMonths,
      startYears,
      startMonths
    );

    const pct = percentOfFRA(monthsEarly);
    const earlyBenefit = monthlyBenefit(fraBenefit, monthsEarly);
    const preFRA = preFRABenefit(earlyBenefit, monthsEarly);

    const monthsBE = monthsToBreakeven(fraBenefit, earlyBenefit, preFRA);
    const ageBE = ageAtBreakeven(startYears, startMonths, monthsBE,fraYears);

    const fvPreFRA = futureValuePreFRA(earlyBenefit, monthsEarly, colaRate);
    const monthsBE_COLA = monthsToBreakevenWithCOLA(
      fraBenefit,
      earlyBenefit,
      fvPreFRA
    );
    const ageBE_COLA = ageAtBreakeven(startYears, startMonths, monthsBE_COLA,fraYears);

    results.push({
      key: age, // unique key for AntD table

      // Table 1 (Interest only)
      "Age to take Social Secuity": `${age}`,
      "Months from Full Retirement Age": monthsEarly,
      "% of FRA Benefit": (pct * 100).toFixed(2),
      "Monthly Benefit": `${earlyBenefit.toFixed(2)}`,
      "Total benefit received up to Age 70": `${preFRA.toFixed(2)}`,
      "Months to break-even with age 70": monthsBE,
      "Age at break-even": ageBE.decimal.toFixed(2),
      "Age at break-even-formated": ageBE.formatted,

      // Table 2 (with COLA)
      "Future value at 70 of pre-70 benefit": `${fvPreFRA.toFixed(2)}`,
      "Months to break-even with age 70 (COLA)": monthsBE_COLA,
      "Age at Break-even": ageBE_COLA.decimal.toFixed(2),
      "Age at Break-even-COLA-formated": ageBE_COLA.formatted,
    });
  }

  return results;
}

// retirementUtils.js
export const calculateRetirementAge = (years, months) => {
  if (years === "") return null;

  let totalMonths = years * 12 + (months || 0);
  let retirementMonths = 67 * 12; // 67 years in months
  let diff = retirementMonths - totalMonths;

  if (diff <= 0) {
    return "0 Years and 0 Months"; // already 67+
  }

  let remainingYears = Math.floor(diff / 12);
  let remainingMonths = diff % 12;

  return `${remainingYears} Years and ${remainingMonths} Months`;
};
